import _ from 'lodash';
import { isEmptyVal } from '@/utils';
import { defaultMapper, getCartInfo } from '@/common/service/default-mapper';
import {
  BILLING_CYCLE, billingCycleDependBasePlanTypeList, BillingCycleEnum,
  dependMeetingPlanTypeList,
  EventSaasCoreConsumptionCategory,
  licenseDependBasePlanTypeList,
  planTypes,
} from '@/common/constants';
import { EventParentCategoryCode } from '@/plans/EVENT_SAAS/helper/constant';
import { getConsumptionCode } from '@/plans/EVENT_SAAS/helper/parse';
import { planUnitMap } from '@/common/product-unit';

export const ZECConsumptionCodes = [];

export const EventSaasCoreCategories = [
  'eventsaascore100',
  'eventsaascore500',
  'eventsaascore1000',
  'eventsaascore3000',
  'eventsaascore5000',
  'eventsaascore10000',
  'ze_consumption_price_list',
  'ze_only_overage_price_list',
];

export function isEventSassCorePlan(planType = '') {
  return EventSaasCoreCategories.includes(planType);
}

export const ConsumptionAttendees = [50, 100, 600, 1000, 3000, 5000, 10000];

export default (planMapJSON) => {
  return EventSaasCoreCategories.reduce((pre, key) => {
    const categoryValue = planMapJSON[key];
    const type = planTypes.EVENT_SAAS_CORE;
    const typeNameKey = 'billing.planform.title.eventsaascore';

    if (isEmptyVal(categoryValue)) {
      return pre;
    }
    // consumption plan
    if (categoryValue[EventSaasCoreConsumptionCategory]) {
      const billing_cycle = BILLING_CYCLE.PAY_PER_ATTENDEE;
      const {
        yearly_plan_code,
        prices,
      } = categoryValue[EventSaasCoreConsumptionCategory];

      if (yearly_plan_code) {
        if (!ZECConsumptionCodes.includes(yearly_plan_code)) {
          ZECConsumptionCodes.push(yearly_plan_code);
        }

        const getPriceByAttendees = (attendees) => {
          const priceStep = prices.find(item => item.start <= attendees && item.end >= attendees);
          return (priceStep.price || 0) * attendees;
        };

        const consumptionList = ConsumptionAttendees.map(attendees => ({
          type,
          typeNameKey,
          min: 1,
          max: 1,
          billing_cycle,
          capacity: attendees,
          category: `${EventSaasCoreConsumptionCategory}${attendees}`,
          plan_code: getConsumptionCode(yearly_plan_code, attendees),
          cartInfo: getCartInfo(),
          amount: getPriceByAttendees(attendees),
          parent_category: EventParentCategoryCode,
          billingCycleDependBasePlanTypeList,
          licenseDependBasePlanTypeList,
          dependBasePlanTypeList: dependMeetingPlanTypeList,
          supportCoupon: true,
          // Only for ppa plan
          originPlanCode: yearly_plan_code,
          isPPA: true,
          unit: planUnitMap.license,
          planNameKey: 'billing.planform.title.eventsaascore_consumption'
        }));

        return [...pre, ...consumptionList];
      }

      return pre;
    }

    // saas planList
    const planList = _.chain(defaultMapper(planMapJSON[key], type))
      .map(item => {
        return ({
          ...item,
          typeNameKey,
          planNameKey: 'billing.planform.title.eventsaascore',
          parent_category: EventParentCategoryCode,
          capacity: planMapJSON[key]?.participants,
          isSaas: true,
          billingCycleDependBasePlanTypeList,
          licenseDependBasePlanTypeList,
          dependBasePlanTypeList: dependMeetingPlanTypeList,
          unit: planUnitMap.license,
          // FREE TRIAL
          isOnlineFreeTrial: false,
          trialDays: undefined,
          trialCode: ''
        });
      })
      .filter((p) => {
        const billingCycle = p.billing_cycle;

        if (BillingCycleEnum[billingCycle] >= BillingCycleEnum[BILLING_CYCLE.QUARTERLY]) {
          return true;
        } else if (p.capacity === 100 && billingCycle === BILLING_CYCLE.MONTHLY) {
          return true;
        }

        return false;
      })
      .value();
    // saas plan list
    return [
      ...pre,
      ...planList,
    ];
  }, []);
}
